<div class="row section_report">
   <div class="col">
    @if(iframeSrc){
        @if(tenant === 'CORE'){
            <iframe [src]="iframeSrc" title="Reports" sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-downloads"></iframe>
        } @else if (tenant === 'SIAG') {
            <iframe [src]="iframeSrc" style="border:0" allowfullscreen  title="Reports" sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"></iframe>
        } @else if (tenant === 'EDIDOMUS') {
            <iframe width="600" height="450" [src]="iframeSrc" title="Reports" style="border:0" allowfullscreen sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"></iframe>
        }
    } @else {
            <div class="empty-page">
                Non sono momentaneamente presenti reports da consultare
            </div>
        }
   </div>
</div>